var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConferenceCallSkype(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ffffff;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "conference_call_skype") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,32V9a2,2,0,0,0-2-2H22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,32H47v1a4,4,0,0,1-4,4H29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,24.47A6.88,6.88,0,0,1,33,23h0c2.25,0,5,1.7,5,3v3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,13a2.86,2.86,0,0,1,3,2.52v2a3,3,0,0,1-6,0v-2A2.86,2.86,0,0,1,33,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,17a5.69,5.69,0,0,0,6-6V7a5.71,5.71,0,0,0-6-6A5.69,5.69,0,0,0,8,7v4A5.71,5.71,0,0,0,14,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,38V27.54c0-5-8.57-7.64-13-7.64S1,22.5,1,27.54V38"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConferenceCallSkype);
export default __webpack_public_path__ + "static/media/conference-call-skype.70389d9f15668b2e0785455f8836dd6b.svg";
export { ForwardRef as ReactComponent };